import React from 'react'
 import './Submit.css'
import Lottie from 'react-lottie';
import * as animationData from './Submit.json';
const Submit = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <div className='Submit'>
                <Lottie className=" lotties"
                    options={defaultOptions}
                />
            </div>
        </>
    )
}

export default Submit